module.exports = __webpack_public_path__ + "static/media/facebook-logo.ab92ad6d.svg";